import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { parse } from 'date-fns';

import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import { token } from '@atlaskit/tokens';

import { Day } from '../Day';
import { useUserInfo } from '../../../store/userInfoStore';

export const End = () => {
	const { trialEndDate } = useUserInfo();
	const endTitle = (
		<div>
			<FormattedMessage
				id="end-of-trial-payment-modals.standard.timeline.1-day-left.title"
				defaultMessage="{end, date, long}: Trial ends"
				description="Title for 1-day left timeline item"
				values={{ end: parse(trialEndDate || '', 'yyyy-MM-dd', new Date()) }}
			/>
		</div>
	);

	const endSubtitle = (
		<FormattedMessage
			id="end-of-trial-payment-modals.standard.timeline.1-day-left.subtitle"
			defaultMessage="Add payment details to keep Standard features, or downgrade to Free."
			description="Subtitle for 1-day left timeline item"
		/>
	);

	return (
		<Day
			title={endTitle}
			subtitle={endSubtitle}
			icon={
				<CalendarIcon label="trial ends" primaryColor={token('color.text.subtlest')} size="small" />
			}
			finalDay
		/>
	);
};
